export default class ProblemReceiveItemDeletionDetails {
    constructor(problemItemId, deletionStatus, errorMessage) {
        this.problemItemId = problemItemId;
        this.deletionStatus = deletionStatus;
        this.errorMessage = errorMessage;
    }
}